import { DeleteOutlined } from '@ant-design/icons';
import { Button, Card, Space } from 'antd';
import React from 'react';
import ConditionBuilder from '../conditions/ConditionBuilder';
import TransformationCard from '../transformations/TransformationCard';

const ChainStepSortable = ({ step, index, onStepChange, onRemoveStep }) => {
  // Ensure condition has default 'equals' operator
  const defaultCondition = {
    field: '',
    operator: 'equals_str',
    value: '',
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <Card
        size="small"
        title={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}
          >
            <span>Étape {index + 1}</span>
          </div>
        }
        extra={
          <Space>
            <Button
              danger
              icon={<DeleteOutlined />}
              size="small"
              onClick={() => onRemoveStep(index)}
            />
          </Space>
        }
        styles={{
          body: { backgroundColor: '#f5f5f5' },
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {/* Step Condition */}
          <div>
            <ConditionBuilder
              onRemove={() => {
                onStepChange(index, { ...step, condition: defaultCondition });
              }}
              condition={step.condition}
              onChange={(newCond) =>
                onStepChange(index, { ...step, condition: newCond })
              }
              fieldNamePrefix={['chain', 'steps', index, 'condition']}
            />
          </div>
          {/* Step Transformation */}
          <div>
            <TransformationCard
              transformationData={step.transformation}
              onTransformationChange={(newTrans) =>
                onStepChange(index, { ...step, transformation: newTrans })
              }
              isControlled={true}
              fieldNamePrefix={['chain', 'steps', index, 'transformation']}
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ChainStepSortable;
